export enum ProposalCardStatusEnum {
  APROVED = "Aprovada",
  REJECTED = "Reprovada",
  IN_PROGRESS = "Em andamento",
  EFFECTIVE = "Efetivada",
  INACTIVE = "Inativo",
  APROVED_CREDIT_DESK = "Aprovada na mesa de Crédito",
  REJECTED_CREDIT_DESK = "Reprovada na Mesa de Crédito",
  ANALYSIS_CREDIT_DESK = "Em análise na Mesa de Crédito",
  DRAFT = "Rascunho"
}

export enum DocumentOrientationEnum {
  HORIZONTAL = "HORIZONTAL",
  VERTICAL = "VERTICAL"
}

export enum ProposalCardTypeEnum {
  FID = "FID",
  FID_CREDIT = "FID E CRÉD",
  NONE = ""
}

export enum LimitReassessmentEnum {
  ANALYSIS = "N", //ANÁLISE
  REANALYSIS = "S" //REANÁLISE
}

export enum ProposalCardTypeLabelEnum {
  FIDELITY = "Fidelidade",
  FIDELITY_CREDIT = "Fidelidade e Crédito"
}

export enum MartialStatusEnum {
  SOLTEIRO = "S",
  CASADO = "C",
  DIVROCIADO = "D",
  SEPARADO_JUDICIALMENTE = "J",
  VIUVO = "V",
  OUTROS = "O",
  UNIAO_ESTAVEL = "U"
}

export enum GenderEnum {
  MALE = "M",
  FEMALE = "F"
}

export enum RelationshipEnum {
  DAD_MOTHER = "Pai ou Mãe",
  SON_DAUGHTER = "Filho(a)",
  GRANDFATHER_GRANDMOTHER = "Avo ou Avó",
  GRANDSON_GRANDDAUGHTER = "Primo(a)",
  BROTHER_SISTER = "Irmão(a)",
  COUPLE = "Cónjuge",
  NEPHEW_NUN = "Sogro(a)",
  UNCLE_AUNT = "Tio(a)",
  NEIGHBOR = "Vizinho",
  FRIENDS = "Amigo(a)",
  COLLEAGUE = "Colega de trabalho",
  NIECE_NEPHEW = "Nora ou Genro"
}

export enum RequiredDocumentTypeEnum {
  DOCUMENT_FRONT = "0001",
  DOCUMENT_BACK = "0010",
  BIOMETRY_FACE = "0009",
  /** Full identity document file from Unico when CPF document is reused (Unico `reused_doc`) */
  REUSED_IDENTITY_DOCUMENT = "0017",
  BIOMETRY = "0026"
}

export enum DocumentTypeEnum {
  DOCUMENT_FRONT = "0001",
  CPF = "0002",
  ADDRESS_PROOF = "0003",
  INCOME_PROOF = "0004",
  DEBIT_SALE_PROOF = "0005",
  SIGNED_ADHESION_PROPOSAL = "0006",
  FOREIGNER_REGISTRATION = "0007",
  CONTESTATION_LETTER = "0008",
  BIOMETRY = "0009",
  BIOMETRY_ID = "0026",
  DOCUMENT_BACK = "0010",
  REUSED_IDENTITY_DOCUMENT = "0017",
  PJ_CNPJ_MATRIX = "0020",
  PJ_SOCIAL_CONTRACT = "0021",
  PJ_BUREAU_CREDIT = "0022",
  NOT_USED_0102 = "0102",
  NOT_USED_0103 = "0103",
  NOT_USED_0104 = "0104",
  NOT_USED_0105 = "0105",
  NOT_USED_0106 = "0106",
  CLIENT_PHOTO = "9999"
}

/**
 * Checks if a document type is handled by Unico platform
 * @param type - Document type code (e.g., "0001", "0009", "0010")
 * @returns true if the document type is handled by Unico
 */
export const isUnicoDocumentType = (type: string): boolean => {
  const unicoTypes = [
    DocumentTypeEnum.BIOMETRY,
    DocumentTypeEnum.BIOMETRY_ID,
    DocumentTypeEnum.DOCUMENT_FRONT,
    DocumentTypeEnum.DOCUMENT_BACK,
    DocumentTypeEnum.REUSED_IDENTITY_DOCUMENT
  ];
  return unicoTypes.includes(type as DocumentTypeEnum);
};

/**
 * Returns array of all Unico document types
 * @returns Array of Unico document type codes
 */
export const getUnicoDocumentTypes = (): string[] => {
  return [
    DocumentTypeEnum.BIOMETRY,
    DocumentTypeEnum.DOCUMENT_FRONT,
    DocumentTypeEnum.DOCUMENT_BACK
  ];
};
